<template>
  <div class="content-main-modal fadeIn animated">
    <transition
      name="form-animation"
      enter-active-class="animated bounceInRight"
      leave-active-class="animated bounceOutRight">
      <div
        v-if="open"
        :class="{'large-modal':width === 'large', 'medium-modal': width === 'medium', 'short-modal':width === 'short'}"
        class="main-modal">
        <el-container
          direction="vertical"
          class="container">
          <el-header>
            <h1>{{ title }}</h1>
            <el-button
              class="close-button"
              @click="onClose">
              <i class="icon-x"/>
            </el-button>
          </el-header>
          <el-main>
            <slot/>
          </el-main>
        </el-container>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'FormPanel',
  props: {
    width: {
      type: String,
      default: 'medium'
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      open: false
    }
  },
  mounted () {
    this.open = true
  },
  methods: {
    onClose () {
      this.open = false
      setTimeout(() => {
        this.$emit('closePanel')
      }, 600)
    }
  }
}
</script>

<style scoped lang="scss">
  .content-main-modal {
    position: fixed;
    height: 100vh;
    width: 100vw;
    top: 0;
    left: 0;
    z-index: 2000;
    background-color: rgba(0, 0, 0, 0.3);
    .main-modal{
      background-color: #ffffff;
      height: 100vh;
      position: absolute;
      top: 0;
      right: 0;
      border-left: 1px solid $border-primary;
      z-index: 2001;
      .close-button{
        border: none;
        position: absolute;
        top: 12px;
        right: 0px;
        font-size: 16px;
      }
      h1 {
        @include font-lato(21px, regular);
        color: #707070;
      }
      .container {
        padding: 0px;
        overflow: auto;
        height: 100vh;
        display: flex;
        flex-direction: column;
      }
      .el-main {
        padding: 0px;
      }
    }
    .large-modal{
      width: 740px;
    }
    .medium-modal{
      width: 550px;
    }
    .short-modal{
      width: 400px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/_shared/form-panel.vue